import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ListLinks } from '../../../@core/constants/list-links';
import { Dialog } from '../../../@core/services/modal/modal.interfaces';
import { JsoNataSchema } from '../../../generated/generated-types';
import { JsoNataSchemaService } from '../../../modules/documents/services/jsonata-schema.service';
import { GenericBaseModelDropDown } from '../genericBaseModelDropDown';

@Component({
  selector: 'app-json-nata-schema-dropdown',
  template: '',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FormlyModule
  ]
})
export class JsoNataSchemaDropdownComponent extends GenericBaseModelDropDown<JsoNataSchema> implements Dialog<any> {
  resolveWith: (result?: any) => void;

  constructor(
    private jsoNataSchemaService: JsoNataSchemaService
  ) {
    super(jsoNataSchemaService, "JsoNataSchema");
    this.listUrl.set(ListLinks.CONVERTER_JSONATA_SCHEMAS);
  }
}
